import { ApolloClient, InMemoryCache } from '@apollo/client';
import { useMutation, useQuery } from '@apollo/react-hooks';

const apiConfig = {
  prod: '11ed524087cf0a6d0f179ac526c99cd9',
  dev: '11ed524087cf0a6d0f179ac526c99cd9'
};

/**
 * ApolloClient - client
 * Used for fetching data from the GraphQL endpoint.
 */
const client = new ApolloClient({
  uri: `${
    window.location.origin
  }/pimcore-graphql-webservices/modules?apikey=${
    process.env.NODE_ENV === 'production'
      ? apiConfig.prod
      : apiConfig.dev
  }`,
  cache: new InMemoryCache(),
  request: async (operation) => {
    operation.setContext({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }
});

export function useModulesQuery(query, config) {
  return useQuery(query, { client, ...config });
}

export function useModulesMutation(mutation, config) {
  return useMutation(mutation, { client, ...config });
}
